import axios from "axios";
import Cookies from "js-cookie";
import config from "./../../config.json";

const methods = ["get", "post", "put", "patch", "delete"];

const baseURL = process.env.REACT_APP_BASE_URL || config.url;

const formatUrl = path => baseURL + path;

const axiosCreator = fetchOptions =>
  axios.create({
    baseURL: baseURL,
    headers: fetchOptions.headers,
  });

function fetchCreator(method, url, options = {}) {
  options.method = method;
  return this.request(url, options);
}

class ApiCall {
  constructor() {
    methods.forEach(method => {
      this[method] = fetchCreator.bind(this, method);
    });
  }

  request(url, { data, ...options } = {}) {
    const { method, ...fetchOptions } = options;

    this.headersHandler(fetchOptions);

    this.dataHandler(data, fetchOptions);

    const instance = axiosCreator(fetchOptions);

    return instance[method](formatUrl(url), data);
  }

  dataHandler(data, fetchOptions) {
    if (data) {
      if (fetchOptions.type === "formdata") {
        fetchOptions.body = new FormData();

        for (const key in data) {
          if (
            typeof key === "string" &&
            data.hasOwnProperty(key) &&
            typeof data[key] !== "undefined"
          ) {
            fetchOptions.body.append(key, data[key]);
          }
        }
      } else {
        fetchOptions.body = JSON.stringify(data);
      }
    }
  }

  headersHandler(fetchOptions) {
    let parsedCookieItem = {};

    fetchOptions.headers = fetchOptions.headers || {};
    fetchOptions.headers["Accept"] = "application/json";
    fetchOptions.headers["Content-Type"] = "application/json";

    if (Cookies.get("appData")) {
      parsedCookieItem = JSON.parse(Cookies.get("appData"));
    }

    if (this.token || parsedCookieItem.token) {
      fetchOptions.headers["X-Authorization"] = `Bearer ${
        this.token || parsedCookieItem.token
      }`;
    }
  }
}

export default new ApiCall();
